<template>
  <el-container v-title data-title="食堂货品" style="min-height:98vh">
    <el-header style="text-align: right; font-size: 12px; height: 105px; background-image: linear-gradient(to right, white , green);">
      <Top/>
    </el-header>
    <el-container>
      <el-aside width="200px" style="background-color: rgb(238, 241, 246)">
        <Menu @GoTo='goto'></Menu>
      </el-aside>
      <el-main style="width: 1px">
        <el-header style="height: auto; padding: 0; background-color: #FFF">
          <el-container>
            <el-header height="20px" style="padding: 0; background-color: #FFF">
              <el-breadcrumb separator="/">
                <el-breadcrumb-item>学生点餐</el-breadcrumb-item>
                <el-breadcrumb-item>套餐设置</el-breadcrumb-item>
              </el-breadcrumb>
            </el-header>
            <el-main>
              <el-form :inline="true" :model="searchForm" class="demo-form-inline" >
                <el-form-item label="学校">
                  <el-select v-model="searchForm.schoolId" filterable>
                    <el-option v-for="(item, index) in schoolList" :key="index" :label="item.name" :value="item.id"></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item label="名称">
                  <el-input v-model="searchForm.name" placeholder="名称"></el-input>
                </el-form-item>
                <el-form-item label="状态">
                  <el-select v-model="searchForm.status">
                    <el-option label="全部" value=""></el-option>
                    <el-option label="启用" value="1"></el-option>
                    <el-option label="停用" value="0"></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item label="每页条数">
                  <el-select v-model="pageSize" @change="handleSizeChange" style="width:80px">
                    <el-option v-for="(item, index) in pageSizes" :key="index" :label="item" :value="item"></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item>
                  <el-button type="primary" @click="getStudentCanteenGoodsList">查询</el-button>
                  <el-button v-if="selectedSchoolId != 97" type="primary" @click="openAddDialog">新增</el-button>
                </el-form-item>
              </el-form>
            </el-main>
          </el-container>
        </el-header>
        <el-table v-loading="loading" :data="tableData" border stripe>
          <el-table-column prop="schoolName" label="学校" width="140"></el-table-column>
          <el-table-column prop="name" label="套餐名称" width="100"></el-table-column>
          <el-table-column prop="descr" label="套餐描述" width="500"></el-table-column>
          <el-table-column prop="statusName" label="状态" width="60"></el-table-column>
          <el-table-column prop="insertTime" label="创建时间" width="170"></el-table-column>
          <el-table-column prop="creatorRealName" label="创建人" width="90"></el-table-column>
          <el-table-column prop="updateTime" label="修改时间" width="170"></el-table-column>
          <el-table-column prop="updaterRealName" label="修改人" width="90"></el-table-column>
          <el-table-column v-if="selectedSchoolId != 97" label="操作" width="141">
            <template slot-scope="scope">
              <el-button type="text" @click="openModifyDialog(scope.row)">修改</el-button>
              <el-button type="text" @click="changeStatus(scope.row)">{{ scope.row.status == '1' ? '停用' : '启用' }}</el-button>
            </template>
          </el-table-column>
        </el-table>
        <div>
          <el-pagination
            background
            @size-change="handleSizeChange"
            @current-change="getStudentCanteenGoodsList"
            :current-page.sync="currentPage"
            :page-sizes="pageSizes"
            :page-size="pageSize"
            :total="total"
            layout="total,sizes,prev,pager,next" >
          </el-pagination>
        </div>
      </el-main>
      <!-- 弹窗页（新增） -->
      <el-dialog
        title="新增"
        :visible.sync="addDialogVisible"
        width="380px"
        :before-close="handleClose"
        append-to-body>
        <el-form ref="addForm" :model="addData" :rules="rules" label-width="90px">
          <el-form-item label="套餐名称" :required="true" prop="name">
            <el-input v-model="addData.name" style="width: 200px"></el-input>
          </el-form-item>
          <el-form-item label="套餐描述" prop="descr">
            <el-input type="textarea" v-model="addData.descr" :rows="4" placeholder="请输入套餐描述"></el-input>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="addStudentCanteenGoods">新增</el-button>
            <el-button @click="addDialogVisible = false">取消</el-button>
          </el-form-item>
        </el-form>
      </el-dialog>
      <!-- 弹窗页（修改） -->
      <el-dialog
        title="修改"
        :visible.sync="modifyDialogVisible"
        width="380px"
        :before-close="handleClose">
        <el-form ref="modifyForm" :model="modifyData" :rules="rules" label-width="90px">
          <el-form-item label="套餐名称" :required="true" prop="name">
            <el-input v-model="modifyData.name" style="width: 200px"></el-input>
          </el-form-item>
          <el-form-item label="套餐描述" prop="descr">
            <el-input type="textarea" v-model="modifyData.descr" :rows="4" placeholder="请输入套餐描述"></el-input>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="modifyStudentCanteenGoods">修改</el-button>
            <el-button @click="modifyDialogVisible = false">取消</el-button>
          </el-form-item>
        </el-form>
      </el-dialog>
    </el-container>
  </el-container>
</template>

<script>
import Top from './Top.vue'
import Menu from './Menu.vue'
export default ({
  components: {
    Menu,
    Top
  },
  data () {
    return {
      userInfo: {},
      schoolList: [],
      tableData: [],
      loading: false,
      currentPage: 1,
      pageSize: 15,
      pageSizes: [15, 50, 100, 150, 200, 300, 500, 1000, 2000],
      total: 0,
      searchForm: {
        schoolId: null,
        status: ''
      },
      addData: {
        schoolId: null
      },
      addDialogVisible: false,
      modifyData: {
        schoolId: null
      },
      modifyDialogVisible: false,
      rules: {
        name: [{ required: true, message: '请输入套餐名称', trigger: 'blur' }]
      },
      selectedSchoolId: null
    }
  },
  mounted () {
    if (this.Cookie.get('userInfo') !== undefined && this.Cookie.get('userInfo') !== '') {
      this.userInfo = JSON.parse(this.Cookie.get('userInfo'))
      this.getSchoolList()
    }
  },
  methods: {
    goto (url) {
      if (url === this.$route.path) return
      this.$router.push(url)
    },
    handleClose (done) {
      done()
    },
    handleSizeChange (pageSize) {
      this.pageSize = pageSize
      this.getStudentCanteenGoodsList()
    },
    getSchoolList () {
      let _this = this
      this.$axios.post(this.GLOBAL.host + '/school/list',
        this.$qs.stringify({
          currentUserId: _this.userInfo.id
        })
      ).then(res => {
        if (res.data != null) {
          if (res.data.status === 200) {
            _this.schoolList = res.data.data.list
            if (_this.schoolList.length > 0) {
              _this.searchForm.schoolId = _this.schoolList[0].id
              _this.getStudentCanteenGoodsList()
            }
          } else {
            this.$message.error(res.data.message)
          }
        }
      })
    },
    getStudentCanteenGoodsList () {
      let _this = this
      _this.loading = true
      this.$axios.post(this.GLOBAL.host + '/studentCanteenGoods/list', {
        schoolId: _this.searchForm.schoolId,
        nameLike: _this.searchForm.name,
        status: _this.searchForm.status,
        page: _this.currentPage,
        size: _this.pageSize
      }).then(res => {
        if (res.data != null) {
          if (res.data.status === 200) {
            _this.total = res.data.data.total
            _this.tableData = res.data.data.list
            _this.selectedSchoolId = _this.searchForm.schoolId
          } else {
            this.$message.error(res.data.message)
          }
        }
        _this.loading = false
      })
    },
    openAddDialog () {
      this.addDialogVisible = true
    },
    addStudentCanteenGoods () {
      let _this = this
      this.$refs['addForm'].validate((valid) => {
        if (valid) {
          _this.addData.schoolId = _this.searchForm.schoolId
          this.$axios.post(this.GLOBAL.host + '/studentCanteenGoods/add',
            _this.addData
          ).then(res => {
            if (res.data != null) {
              if (res.data.status === 200) {
                _this.addDialogVisible = false
                this.$message({
                  message: '新增成功',
                  type: 'success'
                })
                _this.getStudentCanteenGoodsList()
                _this.$refs['addForm'].resetFields()
              } else {
                this.$message.error(res.data.message)
              }
            }
          })
        } else {
          console.log('error submit!!')
          return false
        }
      })
    },
    openModifyDialog (canteenGoodsData) {
      // console.log(canteenGoodsData)
      this.modifyData = JSON.parse(JSON.stringify(canteenGoodsData))
      this.modifyDialogVisible = true
    },
    modifyStudentCanteenGoods () {
      let _this = this
      this.$refs['modifyForm'].validate((valid) => {
        if (valid) {
          _this.modifyData.schoolId = _this.searchForm.schoolId
          this.$axios.post(this.GLOBAL.host + '/studentCanteenGoods/update',
            _this.modifyData
          ).then(res => {
            if (res.data != null) {
              if (res.data.status === 200) {
                _this.modifyDialogVisible = false
                this.$message({
                  message: '修改成功',
                  type: 'success'
                })
                _this.getStudentCanteenGoodsList()
                _this.$refs['modifyForm'].resetFields()
              } else {
                this.$message.error(res.data.message)
              }
            }
          })
        } else {
          console.log('error submit!!')
          return false
        }
      })
    },
    yuanOfPriceFormatter (row) {
      return this.fenToyuanFormat(row.price)
    },
    fenToyuanFormat (fen) {
      let yuan = ''
      if (fen !== 0) {
        yuan = fen / 100 + '元'
      }
      return yuan
    },
    changeStatus (canteenGoodsData) {
      if (canteenGoodsData === null) return
      canteenGoodsData = JSON.parse(JSON.stringify(canteenGoodsData))
      console.log('canteenGoodsData 1: ' + JSON.stringify(canteenGoodsData))
      let _this = this
      this.$confirm('确认要' + (canteenGoodsData.status === '1' ? '停用' : '启用') + '吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        console.log('canteenGoodsData 2: ' + JSON.stringify(canteenGoodsData))
        canteenGoodsData.status = (canteenGoodsData.status === '1' ? '0' : '1')
        this.$axios.post(this.GLOBAL.host + '/studentCanteenGoods/update',
          canteenGoodsData
        ).then(res => {
          if (res.data != null) {
            if (res.data.status === 200) {
              this.$message({
                type: 'success',
                message: '操作成功!'
              })
            }
            _this.getStudentCanteenGoodsList()
          }
        })
      })
    }
  }
})
</script>



// WEBPACK FOOTER //
// src/components/StudentCanteenGoods.vue